export default {"src":"/nachrichten/_next/static/media/ThemeLightIcon.56f276c1.svg","height":124,"width":70,"blurWidth":0,"blurHeight":0};